export enum JoinStep {
  Entry = 0,
  WelcomeBack = 1,
  SelectOffer = 2,
  TeamLeader = 3,
  Agreements = 4,
  MyDetails = 5,
  Vat = 6,
  Payment = 7,
}

export interface JoinKitOption {
  itemId: string
  calloutLabel: string
  price: number
  joinCouponValue: number
  benefitA: string
  benefitB: string
}

export interface JoinKitOptionsResponse {
  offerEndDate: string | null
  options: JoinKitOption[]
}

export interface CheckEmailRequest {
  email: string
}

export interface CheckEmailResponse {
  exists: boolean
  firstName?: string
  lastName?: string
  isActiveDemonstrator: boolean
  isWithinCooldown: boolean
  cooldownEndDate?: string
}

export interface VerifyCustomerRequest {
  username: string
  password: string
  demoId?: number
  isCustomLink?: boolean
}

export interface WelcomeBoxEligibility {
  hasStarterKitOrder: boolean
  welcomeBoxEligible: boolean
  orderDate: string | null
}

export interface TeamLeaderDetails {
  demoId: number
  firstName: string
  lastName: string
  city: string
  suburb?: string
  county?: string
  region: string
  phoneNumber: string
  email: string
  socialMedia?: {
    facebook?: string
    instagram?: string
    twitter?: string
    pinterest?: string
    youtube?: string
    web?: string
  }
  isPreset: boolean
  confirmedAt: string | null
}

export interface RecruitPersonalInfo {
  firstName: string
  lastName: string
  email: string
  homePhone: string
  gender: string
  birthday: string
  formattedBirthday?: string
  identification: string
  secondaryLanguage: string
  // Locale-specific fields
  birthCity?: string
  birthDepartment?: string
  birthCountry?: string
  nationality?: string
  driversLicense?: string
  driversLicenseState?: string
  hasGstNumber?: boolean
  gstNumber?: string
}

export interface VatInfo {
  hasGstNumber: boolean
  gstNumber: string
}

export interface RecruitAddress {
  firstName?: string
  lastName?: string
  addressLine1: string
  addressLine2: string
  addressLine3: string
  city: string
  region: string
  postalCode: string
  country: string
  county: string
  suburb: string
}

export interface RecruitRecord {
  personalInfo: RecruitPersonalInfo
  mailingAddress: RecruitAddress
  shippingAddress: RecruitAddress
  signedAgreements: boolean
  demoDirectoryAgreement: boolean
  uplineId: number | null
  selectedKitItemId: string | null
}

export interface JoinSession {
  email: string
  firstName: string
  lastName: string
  teamLeaderId: string | null
  teamLeader: TeamLeaderDetails | null
  currentStep: JoinStep
  sessionId: string
  agreementsAccepted: boolean
  directoryOptIn: boolean
  // The my-details forms were saved. Not the completeness rule: read the join store's
  // myDetailsCompleted computed, which also requires the config-required personal info. AB#64917
  myDetailsSaved: boolean
  vatInfoCompleted: boolean
  selectedKitItemId: string | null
  hasMultipleKits: boolean
  invoiceId: string | null
}

export interface JoinOrderPayment {
  paymentType: string
  friendlyCardType: string
  maskedAccountNumber: string
  accountLast4: string
  expirationMonth: number | null
  expirationYear: number | null
  cardName: string
  addressLine1: string
  addressLine2: string
  addressLine3: string
  city: string
  region: string
  postalCode: string
  country: string
  phoneNumber: string
}

export interface OrderConfirmationItem {
  itemId: string
  description: string
  price: string
  quantity: number
}

export interface JoinOrderConfirmation {
  orderDate: string
  orderConfirmationNumber: string
  uplineName: string
  shippingAddress: RecruitAddress
  shippingEmailAddress: string
  shippingPhoneNumber: string
  shippingMethod: string
  orderPayment: JoinOrderPayment
  merchandiseSubtotal: string
  shippingAmountNumeric: number
  shippingAmount: string
  taxAmountNumeric: number
  taxAmount: string
  // BC itemizes tax as GST (country) + PST (region) instead of a consolidated taxAmount. #61123
  countryTaxAmount?: string
  regionTaxAmount?: string
  orderTotalNumeric: number
  orderTotal: string
  couponTotal: string
  items: OrderConfirmationItem[]
}
